import React, { useState, useEffect } from 'react';
import { Dropdown } from '@/components/common/toggleDropdown';
import { ImageSliderSimple } from '@/components/common/ImageSliderSimple';
// react-router-dom の Link ではなく LocalizedLink を使用
import { LocalizedLink } from 'src/components/common/LocalizedLink';
import { useLocation } from 'react-router-dom';
// 必要なら API 呼び出し（MenuModal に合わせる場合）
import { getPropertieslist } from '../../API/apiService';

import PictureDaikanyama from '@/image/hotel/picture13.png';
import PictureYoyogi from '@/image/hotel/picture14.png';
import PictureEbisu from '@/image/hotel/ebisu.png';

export const Location: React.FC = () => {
  // useLocation を使って現在の URL パスと言語を取得
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'en';

  // API の結果を使用する場合の例（ここではログ出力するだけ）
  useEffect(() => {
    // API 呼び出しを location の変更でトリガーする
    getPropertieslist()
      .then((response: any) => {
        console.log('Fetched properties:', response.data);
      })
      .catch((error: any) => {
        console.error('Failed to fetch properties:', error);
      });
  }, [location]);

  // 下記の静的データは、既に用意された日本語版・英語版のダミーデータ
  // 日本語版のデータ
  const dropdownDataJP = [
    {
      title: '渋谷',
      content: [
        '渋谷=カオスと思われがちだが、中心の喧騒から1本裏道に入れば、渋谷独自のネイバーフッドが立ち現れる。さまざまな文化が交差しながら発展するこの街では、隠れたローカリティを発見することが醍醐味と言える.',
      ],
      links: [
        { text: 'Shibuya 1', url: '/hotel/1' },
        { text: 'Shibuya 2', url: '/hotel/3' },
      ],
      images: [PictureDaikanyama],
    },
    {
      title: '代々木',
      content: [
        '新宿からも近く、代々木公園や代々木上原などトレンドスポットが集まる注目のエリア。パン屋、コーヒースタンド、レストラン、書店など、東京の今のシーンを語る上で欠かせない数々の店に出会うことができる.',
      ],
      links: [{ text: 'yoyogi 1', url: '/hotel/2' }],
      images: [PictureYoyogi],
    },
    {
      title: '恵比寿',
      content: [
        '華やかな駅前や表通りの景色とは異なり、一本裏道に入れば、こだわりのある大人たちが認めるトレンドに左右されない店が点在している。また、バーの聖地でもある恵比寿の夜は、数々の名店の中からどのバーを選ぶべきか、という難題を楽しむことになる.',
      ],
      links: [{ text: 'Ebisu 1', url: '/hotel/4' }],
      images: [PictureEbisu],
    },
  ];

  // 英語版のデータ
  const dropdownDataEN = [
    {
      title: 'Shibuya',
      content: [
        'Shibuya is often considered chaotic, but venture down a side street and you’ll find unique neighbourhoods away from the bustling centre. All kinds of culture intersects and develops in the area, adding to the excitement of discovering its hidden localities.',
      ],
      links: [
        { text: 'Shibuya 1', url: '/hotel/1' },
        { text: 'Shibuya 2', url: '/hotel/3' },
      ],
      images: [PictureDaikanyama],
    },
    {
      title: 'Yoyogi',
      content: [
        'Located near Shinjuku, the greater Yoyogi area is home to trendy destinations such as Yoyogi Koen and Yoyogi Uehara. Bakeries, coffee stands, restaurants, bookshops and other spots at the forefront of Tokyo’s cultural scene await.',
      ],
      links: [{ text: 'Yoyogi 1', url: '/hotel/2' }],
      images: [PictureYoyogi],
    },
    {
      title: 'Ebisu',
      content: [
        'Contrasting the glamorous station-side area, Ebisu’s back streets are lined with shops for those with a discerning eye. The area’s bars are another drawcard, with almost too many renowned establishments to choose from.',
      ],
      links: [{ text: 'Ebisu 1', url: '/hotel/4' }],
      images: [PictureEbisu],
    },
  ];

  // 現在の言語に応じたデータを選択
  const dropdownData = currentLang === 'ja' ? dropdownDataJP : dropdownDataEN;

  return (
    <div className="pt-24">
      <div className="py-4 text-center text-lg">(LOCATIONS)</div>
      {dropdownData.map((item, index) => (
        <Dropdown key={index} title={item.title}>
          <div className="md:flex md:space-x-8">
            {/* 画像がある場合はスライダー表示 */}
            {item.images.length > 0 && (
              <div className="md:w-1/2 w-full flex justify-center">
                {/* PC時は幅541px, 高さ537px、モバイルでは幅full, 高さ自動 */}
                <div className="w-full md:w-[541px] md:h-[537px] h-auto overflow-hidden">
                  <ImageSliderSimple
                    images={item.images.map((src) => ({ src, title: '' }))}
                  />
                </div>
              </div>
            )}
            <div
              className={
                item.images.length > 0 ? 'md:w-1/2 w-full' : 'md:w-full w-full'
              }
            >
              {item.content.map((contentText, contentIndex) => (
                <p className="py-4 whitespace-pre-line" key={contentIndex}>
                  {contentText}
                </p>
              ))}
              {item.links.map((link, linkIndex) => (
                <div key={linkIndex}>
                  <LocalizedLink
                    to={`/${currentLang}${link.url}`}
                    onClick={() => {
                      // 例えばドロップダウンを閉じるための処理を書く
                    }}
                    className="text-black underline pb-1"
                  >
                    {link.text}
                  </LocalizedLink>
                </div>
              ))}
            </div>
          </div>
        </Dropdown>
      ))}
      <div className="mt-5 text-end underline cursor-pointer">
        <LocalizedLink to={`/${currentLang}/hotel/properties/`}>
          View All Locations &gt;
        </LocalizedLink>
      </div>
    </div>
  );
};

export default Location;
